import client from '../network/client';
import { AuthError, OtpError, TooEarlyError, TooManyError, InvalidCredentialIdError } from '../models/auth-error';

const post = async (path, postBody) => {
  try {
    const { data } = await client.post(`/public/authentication-service/v1${path}`, postBody);
    
    return data;
  } catch ({ response }) {
    const { status, data: eData = {} } = response;
    if (status === 400 && eData.code === 'bad-request' && eData.message === 'The credential ID is invalid.') {
      // XXX: alt. authentication method using passkey
      throw new InvalidCredentialIdError(response);
    }
    if (status === 422) {
      throw new OtpError(response);
    }
    if (status === 425) {
      throw new TooEarlyError(response);
    }
    if (status === 429) {
      throw new TooManyError(response);
    }
    throw new AuthError(response);
  }
};

// @see https://gitlab.com/techcloud/pb/authentication-service/-/blob/master/docs/api/openapi.public.v1.yaml
export default {
  startSession(postBody) {
    return post('/session', postBody);
  },

  startRegistration(sessionId, postBody) {
    return post(`/session/${sessionId}/register`, postBody);
  },

  startCorporateRegistration(sessionId, postBody) {
    return post(`/session/${sessionId}/register-corporate`, postBody);
  },

  confirmEmailOtp(sessionId, postBody) {
    return post(`/session/${sessionId}/confirm`, postBody);
  },
  
  confirmPhoneOtp(sessionId, postBody) {
    return post(`/session/${sessionId}/confirm`, postBody);
  },

  resendOtp(sessionId, postBody) {
    return post(`/session/${sessionId}/resend-otp`, postBody);
  },
  
  logout() {
    return post(`/users/logout`);
  },

  refresh(refreshToken) {
    return post(`/jwt/refresh`, {
      refreshToken,
    });
  },

  loginUsingPasskeys(postBody) {
    return post(`/assertion`, postBody);
  }
};
